export default __webpack_public_path__ + "static/media/1_CertificatoISO14001n2464em1.be462f5a.pdf";